import React, { useState, useEffect } from "react";
import { Container, Row, Col, FormGroup, Label, Input, FormText } from "reactstrap";
import { Formik, Form, Field } from "formik";
import { useNavigate } from "react-router-dom";
import "../share/form.css";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { BiShow } from "react-icons/bi";
import { BiHide } from "react-icons/bi";
import { NumericFormat } from 'react-number-format';
import { CustomInputNumeric } from '../share/CustomInputNumeric'
import { FormikSelect } from "../share/FormikSelect";
import { GetVMdDept, GetTitleName, GetCurProvince, GetProvince } from "../share/api/MasterDataApi";
import { Loading } from "../share/loading";
export function PersonRegisterComponent() {

    const registerationTypeNumber = 2;
    const customerType = "บุคคลธรรมดา";
    const navigate = useNavigate();
    const [isRevealPwd, setIsRevealPwd] = useState(false);
    const [isRevealPwd2, setIsRevealPwd2] = useState(false);
    const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z\d]{8,}$/;
    const [loading, setLoading] = useState(false)
    // state สำหรับดึงข้อมูลจาก master data
    const [deptsData, setDeptsData] = useState([]);
    const [titleName, setTitleName] = useState([]);

    //state สำหรับดึงข้อมูลสำหรับที่อยู่ตามทะเบียนบ้าน 
    const [locationProvince, setLocationProvince] = useState([]);
    const [locationAmphur, setLocationAmphur] = useState([]);
    const [locationTumbon, setLocationTumbon] = useState([]);

    //state สำหรับดึงข้อมูลสำหรับที่อยู่ปัจจุบัน
    const [locationCurProvince, setLocationCurProvince] = useState([]);
    const [locationCurAmphur, setLocationCurAmphur] = useState([]);
    const [locationCurTumbon, setLocationCurTumbon] = useState([]);

    // state สำหรับ function ตอนเลือกประเภทการสมัคร
    const [checkedSkillTesting, setCheckedSkillTesting] = useState(false);

    const [checkedCareerMaker, setCheckCareerMaker] = useState(false);


    // state สำหรับ toggle label หน่วยงานกรมพัฒนฯ
    const [initialDept, setInitialDept] = useState("หน่วยงานกรมพัฒนาฝีมือแรงงานที่ต้องการติดต่อ");

    // state สำหรับดูว่า เลือกประเภทการสมัครเป็น type ไหนบ้าง จะได้ส่งข้อมูลไปหลังบ้าน โดยเลือกจากค่าที่เป็น true แล้ว state regisType จะรับเฉพาะ id ไป
    const [checkedDept, setCheckedDept] = useState([
        {
            id: "2",
            name: "ผู้ดำเนินการฝึก",
            check: false,
            dept: "หน่วยงานกรมพัฒนาฝีมือแรงงานในพื้นที่ที่ผู้ดำเนินการฝึกต้องการติดต่อ",

        },
        {
            id: "3",
            name: "ผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน",
            check: false,
            dept: "หน่วยงานกรมพัฒนาฝีมือแรงงานในพื้นที่ที่ผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงานต้องการติดต่อ",

        },
        // {
        //     id: "6",
        //     name: "ผู้ประกอบอาชีพ",
        //     check: false,
        //     dept: "หน่วยงานกรมพัฒนาฝีมือแรงงานในพื้นที่ที่ต้องการติดต่อ",

        // }
    ]);
    const [regisType, setRegisType] = useState([]);

    const [searchCertificateNo, setSearchCertificateNo] = useState("");
    const [dataCertificate, setDataCertificate] = useState(null);

    useEffect(() => {
        GetVMdDept({ setDeptsData, setLoading })//ดึงmaster data หน่วยงานกรมพัฒฯ
        GetProvince({ setLocationProvince, setLoading })// ดึง master data จังหวัด
        GetCurProvince({ setLocationCurProvince, setLoading }) //  ดึง master data จังหวัด สำหรับเลือกกรอก input ที่อยู่ปัจจุบันที่ติดต่อได้
        GetTitleName({ setTitleName, setLoading }) //ดึงคำนำหน้าชื่อ
    }, []);


    //ดึงอำเภอ สำหรับ copy 
    async function GetCurAmphurForCopy(values) {

        if (values) {
            let postData = new FormData();
            postData.append("provinceCode", values);

            try {
                const responseAmphur = await fetch("/api/MasterData/getAmphur", {
                    method: "POST",
                    body: postData
                });
                const amphurData = await responseAmphur.json()
                setLocationCurAmphur(amphurData.dataenum);
                // console.log(amphurData.dataenum);

            } catch (err) {
                console.log("err =>" + err);
            }
        } else {
            return;
        }

    }

    const initialValues = {
        checkedSkillTesting: checkedSkillTesting,
        checkedCareerMaker: checkedCareerMaker,
        type: registerationTypeNumber,
        customerTypeAr: regisType,
        dept: "",
        registerNumber: "",
        titleId: "",
        fullName: "",
        addNo: "",
        addMoo: "",
        addSoi: "",
        addStreet: "",
        addProvince: "",
        addDistrict: "",
        addTumbon: "",
        postcode: "",
        locationId: "",
        curAddNo: "",
        curAddMoo: "",
        curAddSoi: "",
        curAddStreet: "",
        curAddProvince: "",
        curAddDistrict: "",
        typeBusiness: "", //ประกอบกิจการประเภท
        curAddTumbon: "",
        curPostcode: "",
        locationCurId: "",
        licenseTestName: "",
        tel: "",
        fax: "",
        email: "",
        fCommercial: "",
        testLicenseNo: "",
        password: "",
        cpassword: "",
        term: "N"

    }

    async function checkedSkillTestingPreSubmit() {
        if (checkedSkillTesting) {
            if (dataCertificate === null) {
                return false
            } else {
                return true
            }
        } else {
            return true
        }
    }

    const onSubmit = async (values) => {
        // console.log("form data", values)
        let pass = await checkedSkillTestingPreSubmit()
        if (pass) {
            let postData = new FormData();
            Object.entries(values).forEach(([key, value]) => {
                postData.append(key, value);
            });

            try {
                let res = await fetch("/api/Registeration/saveRegisData", {
                    method: "POST",
                    body: postData
                });
                let resJson = await res.json();
                //console.log(resJson);
                if (resJson.status === 1) {
                    Swal.fire({
                        icon: "success",
                        title: "ลงทะเบียนสำเร็จ",
                        text: "โปรดรอเจ้าหน้าที่ตรวจสอบและยืนยันผ่านทางอีเมล",
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    }).then((result) => {
                        if (result.isConfirmed) {

                            return navigate("/registeration/")
                        }
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "ลงทะเบียนไม่สำเร็จ",
                        text: `เนื่องจาก ${resJson.message}`,
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    });
                }
            } catch (e) {
                console.log(e)
            }
        } else {
            Swal.fire({
                icon: "info",
                title: "",
                text: "ไม่พบข้อมูลเลขที่ใบอนุญาตการเป็นผู้ดำเนินการทดสอบฯ",
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            })
        }

    }


    const validateSchema = Yup.object().shape({
        checkedSkillTesting: Yup.boolean(),
        checkedCareerMaker: Yup.boolean(),
        customerTypeAr: Yup.array().of(
            Yup.string()
        ).min(1, "กรุณาเลือกประเภทการสมัครอย่างน้อย 1 รายการ"),
        dept: Yup.string().required("กรุณาเลือกหน่วยงาน"),
        registerNumber: Yup.string().min(13, "เลขบัตรประจำตัวประชาชน ต้องมีจำนวน 13 หลัก").required("กรุณากรอกเลขบัตรประจำตัวประชาชน (13หลัก)"),
        titleId: Yup.string().required("กรุณาเลือกคำนำหน้าชื่อ"),
        fullName: Yup.string().required("กรุณากรอกชื่อ-นามสกุล"),
        typeBusiness: Yup.string().required("กรุณากรอกประกอบกิจการประเภท"),
        addNo: Yup.string().required("กรุณากรอกเลขที่"),
        addProvince: Yup.string().required("กรุณาเลือกจังหวัด"),
        addDistrict: Yup.string().required("กรุณาเลือกอำเภอ/เขต"),
        addTumbon: Yup.string().required("กรุณาเลือกตำบล/แขวง"),
        postcode: Yup.string()
            .matches(/^[0-9]{5}$/, "รหัสไปรษณีย์ต้องประกอบไปด้วยตัวเลข 5 หลัก")
            .required("กรุณาระบุรหัสไปรษณีย์"),
        curAddNo: Yup.string().required("กรุณากรอกเลขที่"),
        curAddProvince: Yup.string().required("กรุณาเลือกจังหวัด"),
        curAddDistrict: Yup.string().required("กรุณาเลือกอำเภอ/เขต"),
        curAddTumbon: Yup.string().required("กรุณาเลือกตำบล/แขวง"),
        curPostcode: Yup.string()
            .matches(/^[0-9]{5}$/, "รหัสไปรษณีย์ต้องประกอบไปด้วยตัวเลข 5 หลัก")
            .required("กรุณาระบุรหัสไปรษณีย์"),
        tel: Yup.string()
            //   .matches(/^[0-9]{10}$/,"เบอร์โทรศัพท์ต้องประกอบไปด้วยตัวเลข 10 หลักเท่านั้น")
            .required("กรุณากรอกเบอร์โทรศัพท์"),
        fax: Yup.string(),
        // .matches(/^[0-9]{10}$/,"เบอร์โทรสารต้องประกอบไปด้วยตัวเลข 10 หลักเท่านั้น"),
        email: Yup.string()
            .email("รูปแบบอีเมลไม่ถูกต้อง")
            .required("กรุณากรอกอีเมล"),
        fCommercial: Yup.mixed().required("กรุณาแนบไฟล์"),
        licenseTestName: Yup.string().when(
            ["checkedSkillTesting", "checkedCareerMaker"],
            {
                is: (checkedSkillTesting, checkedCareerMaker) =>
                    checkedSkillTesting || checkedCareerMaker,
                then: Yup.string().required("กรุณากรอกข้อมูล"),
            }
        ),
        testLicenseNo: Yup.string().when("checkedSkillTesting", {
            is: true,
            then: Yup.string().required("กรุณากรอกเลขที่ใบอนุญาตดำเนินการทดสอบมาตรฐานฝีมือแรงงาน")
        }),

        password: Yup.string()
            .matches(passwordRegex, 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร ประกอบด้วย ตัวเลข ตัวอักษรตัวใหญ่ และตัวอักษรตัวเล็ก')
            .required("โปรดระบุรหัสผ่าน"),
        cpassword: Yup.string()
            .oneOf([Yup.ref('password'), null], 'รหัสผ่านไม่ตรงกัน')
            .required('กรุณายืนยันรหัสผ่าน'),
        term: Yup.string().oneOf(["Y"], "กรุณายอมรับเงื่ิอนไข").required("กรุณายอมรับเงื่อนไข")

    })



    if (loading) { return <Loading /> }
    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validateSchema}
            onSubmit={onSubmit}
            enableReinitialize
        >
            {(formik) => {
                console.log(formik.values)
                // ดึง master data อำเภอ
                async function GetAmphur(e) {
                    if (e) {
                        let { value } = e.target;
                        // console.log(e.target.value);
                        let postData = new FormData();
                        postData.append("provinceCode", value);

                        try {
                            const responseAmphur = await fetch("/api/MasterData/getAmphur", {
                                method: "POST",
                                body: postData
                            });
                            const amphurData = await responseAmphur.json()
                            setLocationAmphur(amphurData.dataenum);
                            // console.log(amphurData.dataenum);

                        } catch (err) {
                            console.log("err =>" + err);
                        }
                    } else {
                        return;
                    }

                }
                // ดึง master data ตำบล
                async function GetTumbon(e) {
                    if (e) {
                        let postData = new FormData();
                        postData.append("provinceCode", formik.values.addProvince);
                        postData.append("amphurCode", e.target.value);
                        try {
                            let responseTumbon = await fetch("/api/MasterData/getTumbon", {
                                method: "POST",
                                body: postData
                            });
                            const tumbonData = await responseTumbon.json()
                            // setLocationTumbon(tumbonData.dataenum);
                            setLocationTumbon(tumbonData.dataenum);

                        } catch (err) {
                            console.log("err =>" + err);
                        }

                    } else {
                        return;
                    }
                };
                // หา location_id โดยส่ง จังหวัด อำเภอ ตำบล ไปหา เพื่อที่จะเอามาเก็บใน data base เป็น location_id
                async function GetLocationsId(e) {
                    let tumbonId = e.target.value;
                    let provinceId = formik.values.addProvince;
                    let amphurId = formik.values.addDistrict;

                    let postData = new FormData();
                    postData.append("provinceCode", provinceId);
                    postData.append("amphurCode", amphurId);
                    postData.append("tumbonCode", tumbonId);
                    try {
                        let res = await fetch("/api/MasterData/getLocationId", {
                            method: "POST",
                            body: postData
                        });
                        const locationId = await res.json()

                        let setLocationId = locationId.dataenum.map(({ locationId }) => locationId).join().toString();
                        formik.setFieldValue("locationId", setLocationId);
                    } catch (err) {
                        console.log("err =>" + err);
                    }
                }
                // หา location_id โดยส่ง จังหวัด อำเภอ ตำบล ไปหา เพื่อที่จะเอามาเก็บใน data base เป็น locationCurId
                async function GetCurLocationsId(e) {

                    let tumbonId = e.target.value;
                    let provinceId = formik.values.curAddProvince;
                    let amphurId = formik.values.curAddDistrict;

                    let postData = new FormData();
                    postData.append("provinceCode", provinceId);
                    postData.append("amphurCode", amphurId);
                    postData.append("tumbonCode", tumbonId);
                    try {
                        let res = await fetch("/api/MasterData/getLocationId", {
                            method: "POST",
                            body: postData
                        });
                        const locationCurId = await res.json()

                        let id = locationCurId.dataenum.map(({ locationId }) => locationId).join().toString();
                        formik.setFieldValue('locationCurId', id);

                    } catch (err) {
                        console.log("err =>" + err);
                    }
                }
                const SelectDept = (depts) => {
                    const filtered = depts.filter(dept => dept.check === true) // เลือกค่า state ที่มีค่าเป็น true แล้วให้โชว์แค่ตัวเดียว ก็คือ index 0
                    filtered.length >= 1 ? setInitialDept(filtered[0].dept) : setInitialDept("หน่วยงานกรมพัฒนาฝีมือแรงงานที่ต้องการติดต่อ")

                    let regisTypeResult = filtered.map(({ id }) => id);
                    setRegisType(regisTypeResult);
                    // getValuesFormState()
                };
                // จัดการการคลิกเลือกประเภทการสมัคร แล้วส่งค่าที่เลือก ไปยัง SelectDept Function
                const HandleChecked = (e) => {
                    const { target } = e;
                    const { value, checked } = target;

                    // show component แต่ละประเภท
                    if (value === "3") {
                        checked ? setCheckedSkillTesting(!checkedSkillTesting) : setCheckedSkillTesting(false)
                    }

                    if (value === "6") {
                        checked ? setCheckCareerMaker(!checkedCareerMaker) : setCheckCareerMaker(false)
                    }
                    // ส่ง value ไปที่ state ใหม่อีกรอบ แล้วส่งไปใช้ใน SelectDept Function
                    const index = checkedDept.findIndex((dept) => dept.id === value);
                    checkedDept[index].check = checked;
                    setCheckedDept([...checkedDept]);
                    SelectDept(checkedDept); //เรียกใช้ SelectDept
                };
                const handleSubmit = (e) => {
                    e.preventDefault();
                    if (Object.keys(formik.errors).length > 0) {
                        // form has errors
                        let errorText = "";
                        for (const error in formik.errors) {
                            errorText += `<h6>${formik.errors[error]}</h6>`;
                        }
                        Swal.fire({
                            icon: 'error',
                            title: 'ลงทะเบียนไม่สำเร็จ',
                            html: errorText,
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        });
                        // set invalid state of form inputs
                        for (const field in formik.errors) {
                            formik.setFieldTouched(field, true);
                        }
                    } else {
                        formik.handleSubmit(e);
                    }
                }
                async function GetCurTumbon(e) {
                    if (e) {
                        let postData = new FormData();
                        postData.append("provinceCode", formik.values.curAddProvince);
                        postData.append("amphurCode", e.target.value);
                        try {
                            let responseTumbon = await fetch("/api/MasterData/getTumbon", {
                                method: "POST",
                                body: postData
                            });
                            const tumbonData = await responseTumbon.json()
                            // setLocationTumbon(tumbonData.dataenum);
                            setLocationCurTumbon(tumbonData.dataenum);

                        } catch (err) {
                            console.log("err =>" + err);
                        }

                    } else {
                        return;
                    }
                };

                async function copyAddress(e) {
                    if (e.target.checked === true) {
                        await GetCurAmphurForCopy(formik.values.addProvince)
                        await GetCurTumbonForCopy(formik.values.addDistrict)
                        formik.setFieldValue("curAddNo", formik.values.addNo)
                        formik.setFieldTouched("curAddNo", false)
                        formik.setFieldValue("curAddMoo", formik.values.addMoo)
                        formik.setFieldTouched("curAddMoo", false)
                        formik.setFieldValue("curAddSoi", formik.values.addSoi)
                        formik.setFieldTouched("curAddSoi", false)
                        formik.setFieldValue("curAddStreet", formik.values.addStreet)
                        formik.setFieldTouched("curAddStreet", false)
                        formik.setFieldValue("curAddProvince", formik.values.addProvince)
                        formik.setFieldTouched("curAddProvince", false)
                        formik.setFieldValue("curAddDistrict", formik.values.addDistrict)
                        formik.setFieldTouched("curAddDistrict", false)
                        formik.setFieldValue("curAddTumbon", formik.values.addTumbon)
                        formik.setFieldTouched("curAddTumbon", false)
                        formik.setFieldValue("curPostcode", formik.values.postcode)
                        formik.setFieldTouched("curPostcode", false)
                        formik.setFieldValue("locationCurId", formik.values.locationId)
                        formik.setFieldTouched("locationCurId", false)
                    } else {
                        formik.setFieldValue("curAddNo", "")
                        formik.setFieldValue("curAddMoo", "")
                        formik.setFieldValue("curAddSoi", "")
                        formik.setFieldValue("curAddStreet", "")
                        formik.setFieldValue("curAddProvince", "")
                        formik.setFieldValue("curAddDistrict", "")
                        formik.setFieldValue("curAddTumbon", "")
                        formik.setFieldValue("curPostcode", "")
                        formik.setFieldValue("locationCurId", "")
                    }
                }
                // ดึง master data อำเภอ
                async function GetCurAmphur(e) {
                    if (e) {
                        let { value } = e.target;
                        // console.log(e.target.value);
                        let postData = new FormData();
                        postData.append("provinceCode", value);

                        try {
                            const responseAmphur = await fetch("/api/MasterData/getAmphur", {
                                method: "POST",
                                body: postData
                            });
                            const amphurData = await responseAmphur.json()
                            setLocationCurAmphur(amphurData.dataenum);
                            // console.log(amphurData.dataenum);

                        } catch (err) {
                            // console.log("err =>" + err);
                        }
                    } else {
                        return;
                    }

                }

                async function GetCurTumbonForCopy(values) {
                    if (values) {
                        let postData = new FormData();
                        postData.append("provinceCode", formik.values.addProvince);
                        postData.append("amphurCode", values);
                        try {
                            let responseTumbon = await fetch("/api/MasterData/getTumbon", {
                                method: "POST",
                                body: postData
                            });
                            const tumbonData = await responseTumbon.json()
                            setLocationCurTumbon(tumbonData.dataenum);

                        } catch (err) {
                            // console.log("err =>" + err);
                        }

                    } else {
                        return;
                    }
                };
                async function CheckCertificateNo() {
                    try {
                        const res = await fetch("/api/Registeration/getCertificateNo", {
                            method: "POST",
                            headers: { "Content-type": "application/json" },
                            body: JSON.stringify({
                                "certificateNo": searchCertificateNo
                            }),
                        });

                        let resJson = await res.json();
                        if (resJson.dataenum !== null) {
                            let centerName = resJson.dataenum.centerName || "";

                            // ตรวจสอบว่ามีคำว่า 'ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน' หรือยัง
                            if (!centerName.includes("ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน")) {
                                centerName = `ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน ${centerName}`;
                            }

                            setDataCertificate(resJson.dataenum)
                            formik.setFieldValue("testLicenseNo", resJson.dataenum.centerId)
                            formik.setFieldValue("licenseTestName", centerName)
                        } else {
                            Swal.fire({
                                icon: "info",
                                title: "ไม่พบข้อมูล",
                                text: "โปรดตรวจสอบข้อมูลอีกครั้ง",
                                confirmButtonColor: "#0A66C2",
                                confirmButtonText: "ตกลง",
                            }).then(() => {
                                formik.setFieldValue("testLicenseNo", "")
                                formik.setFieldTouched("testLicenseNo", true)
                                setSearchCertificateNo("")
                                setDataCertificate(null)
                            })
                        }

                    } catch (err) {
                        // console.log(err)
                    }
                }

                // console.log(formik.values)

                return (
                    <Container className="d-flex justify-content-center mb-5">
                        <div className="form-border">

                            <Form
                                className="p-5 mb-4"
                                // onSubmit={formik.handleSubmit}
                                onSubmit={handleSubmit}
                                autoComplete="off"
                            >

                                {/* ประเภทผู้สมัคร  */}
                                <h4 className="text-center type-register" >
                                    ประเภทผู้สมัคร :
                                    <span className="customer-type fs-4 mx-1">
                                        {customerType}
                                    </span>
                                </h4>

                                {/* checkbox สำหรับเลือกประเภทการสมัคร */}
                                <FormGroup className="mt-5 d-flex justify-content-start">
                                    <Label
                                        for="customerTypeAr"
                                        name="customerTypeAr">
                                        ประเภทการสมัคร
                                        <span
                                            className="require-input">
                                            *
                                        </span>
                                        {formik.touched.customerTypeAr && formik.errors.customerTypeAr ?
                                            <span
                                                className="text-left text-danger">
                                                {formik.errors.customerTypeAr}
                                            </span> : null
                                        }
                                    </Label>
                                </FormGroup>
                                <div className="ms-5">
                                    <FormGroup>
                                        <Input
                                            type="checkbox"
                                            className={`mx-2 cus-type ${formik.errors.customerTypeAr ? "input-error" : ""}`}
                                            name="trainer"
                                            value="2"
                                            onChange={HandleChecked} />
                                        <Label>ผู้ดำเนินการฝึก</Label>
                                    </FormGroup>

                                    <FormGroup>
                                        <Input
                                            type="checkbox"
                                            className={`mx-2 cus-type ${formik.errors.customerTypeAr ? "input-error" : ""}`}
                                            name="skillTesting"
                                            value="3"
                                            onChange={HandleChecked} />
                                        <Label>ผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน</Label>
                                    </FormGroup>

                                    {/* <FormGroup>
                                        <Input
                                            type="checkbox"
                                            className={`mx-2 cus-type ${formik.errors.customerTypeAr ? "input-error" : ""}`}
                                            name="careerMaker"
                                            value="6"
                                            onChange={HandleChecked} />
                                        <Label>ผู้ประกอบอาชีพ</Label>
                                    </FormGroup> */}

                                </div>


                                {/* input สำหรับเลือกหน่วยงานกรมพัฒฯ */}
                                <FormGroup className="pt-3">
                                    <Label
                                        for="dept">
                                        {initialDept}
                                        <span className="require-input">*</span>
                                        {formik.touched.dept && formik.errors.dept ?
                                            <span className="text-left text-danger px-3">
                                                {formik.errors.dept}
                                            </span>
                                            : null}
                                    </Label>
                                    <Col>
                                        <Field
                                            name="dept"
                                            component={FormikSelect}
                                            options={deptsData}
                                            placeholder={<div className="input-color text-center">กรุณาเลือกหน่วยงาน</div>}
                                        />
                                    </Col>
                                </FormGroup>

                                {/* input สำหรับกรอกเลขบัตรประจำตัวประชาชน 13 หลักฯ */}
                                <FormGroup row>
                                    <Label
                                        for="customer_no">
                                        เลขประจำตัวประชาชน (13หลัก)
                                        <span
                                            className="require-input">
                                            *
                                        </span>

                                        {formik.errors.registerNumber && formik.touched.registerNumber ? (
                                            <span className="text-left text-danger px-1">
                                                {formik.errors.registerNumber}
                                            </span>
                                        ) : null}
                                    </Label>
                                    <Col>

                                        <Field name="registerNumber">
                                            {({ field, meta, form: { setFieldValue, values } }) => (
                                                <NumericFormat
                                                    maxLength={13}
                                                    displayType="number"
                                                    value={values.registerNumber}
                                                    onValueChange={(values, sourceInfo) => {
                                                        setFieldValue(field.name, values.value)
                                                    }}
                                                    customInput={CustomInputNumeric}
                                                    className={formik.errors.registerNumber && formik.touched.registerNumber ? "input-error" : ""}
                                                />
                                            )}
                                        </Field>
                                    </Col>
                                </FormGroup>

                                {/* input สำหรับเลือกคำนำหน้าชื่อและกรอกชื่อ นามสกุล */}
                                <FormGroup row>
                                    <Label
                                        for="customer_no">
                                        ชื่อ (โปรดระบุชื่อ - สกุล)
                                        <span
                                            className="require-input">
                                            *
                                        </span>
                                        {formik.touched.titleId && formik.errors.titleId ?
                                            <span className="text-left text-danger p-3">
                                                {formik.errors.titleId}
                                            </span>
                                            : null
                                        }
                                        {formik.touched.fullName && formik.errors.fullName ?
                                            <span className="text-left text-danger px-1">
                                                {formik.errors.fullName}
                                            </span>
                                            : null
                                        }

                                    </Label>
                                    <div className="d-flex justify-content-start ">
                                        <div className="flex-grow-1">
                                            <Input
                                                className={
                                                    formik.touched.titleId && formik.errors.titleId
                                                        ? "input-error rounded-pill rounded-end text-center input-color"
                                                        : "rounded-pill rounded-end text-center input-color"
                                                }
                                                type="select"
                                                name="titleId"
                                                id="titleId"
                                                onBlur={formik.handleBlur}
                                                onChange={(e) => {
                                                    formik.handleChange(e);
                                                }}
                                                value={formik.values.titleId}
                                            >
                                                <option defaultValue={"คำนำหน้า"}>คำนำหน้า</option>
                                                {titleName.map((title, i) => (
                                                    <option
                                                        key={title.titleCode}
                                                        value={title.titleCode}
                                                    >
                                                        {title.titleThai}
                                                    </option>
                                                ))}
                                            </Input>
                                        </div>

                                        <div className="w-75">
                                            <Input
                                                className={
                                                    formik.touched.fullName && formik.errors.fullName
                                                        ? "input-error rounded-pill rounded-start text-center input-color"
                                                        : " rounded-pill rounded-start text-center input-color"
                                                }
                                                type="text"
                                                name="fullName"
                                                id="fullName"
                                                placeholder="ชื่อ-สกุล"
                                                onBlur={formik.handleBlur}
                                                onChange={(e) => {
                                                    formik.handleChange(e);
                                                }}
                                                value={formik.values.fullName}
                                            />
                                        </div>
                                    </div>
                                </FormGroup>

                                {/* เช็คว่ามีการเลือกประเภทเป็น ผู้ดำเนินการทดสอบไหม */}
                                {checkedSkillTesting ? (
                                    <>
                                        <div>
                                            <FormGroup
                                                row
                                                className="pt-2" >
                                                <Label
                                                    for="test_license_no">
                                                    เลขที่ใบอนุญาตการเป็นผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน
                                                    <span
                                                        className="require-input">
                                                        *
                                                    </span>
                                                    {formik.touched.testLicenseNo && formik.errors.testLicenseNo ?
                                                        <span className="text-left text-danger px-1">
                                                            {formik.errors.testLicenseNo}
                                                        </span> : null
                                                    }
                                                </Label>
                                                <div className="d-flex">
                                                    <Input
                                                        type="text"
                                                        name="testLicenseNo"
                                                        {...formik.getFieldProps("testLicenseNo")}
                                                        // value={certificate24}
                                                        className={
                                                            formik.touched.testLicenseNo && formik.errors.testLicenseNo ?
                                                                "input-error rounded-pill rounded-end text-center input-color" :
                                                                "rounded-pill rounded-end text-center input-color"
                                                        }
                                                        onChange={(e) => {
                                                            formik.handleChange(e)
                                                            setSearchCertificateNo(e.target.value)
                                                        }}
                                                    // placeholder="ตัวอย่างการใส่เลขที่ใบอนุญาต เช่น สข-0000/2564"
                                                    />
                                                    <button
                                                        type="button"
                                                        // disabled={startDate < new Date() && new Date() < endDate ? true:false}
                                                        className="btn border border-1 rounded-pill rounded-start text-center input-color"
                                                        onClick={() => {
                                                            CheckCertificateNo() // ขอ data
                                                        }}>
                                                        ค้นหา
                                                    </button>
                                                </div>

                                            </FormGroup>
                                        </div>
                                    </>
                                ) : null}

                                {dataCertificate !== null ?
                                    <>
                                        <div className="cus-type mx-2">
                                            <div className="my-3 px-3">
                                                <h4 className="text-center input-color">ข้อมูลศูนย์ทดสอบมาตรฐานฝีมือแรงงาน</h4>
                                                <Label className="">ชื่อศูนย์ทดสอบมาตรฐานฝีมือแรงงาน : <span className="input-color">{dataCertificate?.centerName}</span></Label>
                                                <Label className="mt-2">ชื่อหน่วยงานกรมพัฒนาฝีมือแรงงานในพื้นที่ที่ศูนย์ฝึกอบรมฝีมือแรงงาน: </Label>
                                                <Input
                                                    disabled={true}
                                                    className="rounded-pill text-center input-color"
                                                    value={dataCertificate?.site}
                                                />
                                                <Label className="mt-2 w-100 mt-2">วันที่เริ่มดำเนินงาน : <span className="input-color">{dataCertificate?.dateCreate}</span></Label>
                                                <Label className="mt-2 w-100 mt-2">สถานะการดำเนินงาน : <span className="input-color">{dataCertificate?.workOn === "1" ? "ยังดำเนินการอยู่" : ""}</span></Label>

                                                <div className="mt-2">
                                                    <Label>ที่อยู่ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน:
                                                        <span className="input-color mx-1">{dataCertificate?.address ?? "-"}</span>
                                                        เบอร์โทร : <span className="input-color mx-1">{dataCertificate?.telNo ?? "-"}</span>
                                                        อีเมล : <span className="input-color mx-1">{dataCertificate?.email ?? "-"}</span>
                                                    </Label>
                                                </div>
                                            </div>
                                        </div>


                                    </> : null}

                                {(checkedSkillTesting == true || checkedCareerMaker == true) ? (
                                    <FormGroup
                                        row
                                        className="pt-3" >
                                        <Label
                                            for="test_license_no">
                                            ชื่อ (ผู้ขอรับเงินช่วยเหลือหรืออุดหนุน)
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {formik.touched.licenseTestName && formik.errors.licenseTestName ?
                                                <span className="text-left text-danger px-1">
                                                    {formik.errors.licenseTestName}
                                                </span> : null
                                            }
                                        </Label>
                                        <br />
                                        <Col>
                                            <Input
                                                className=
                                                {formik.touched.licenseTestName && formik.errors.licenseTestName ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                }
                                                type="text"
                                                name="licenseTestName"
                                                disabled={checkedSkillTesting}
                                                // disabled
                                                {...formik.getFieldProps("licenseTestName")}
                                            />
                                        </Col>
                                    </FormGroup>
                                ) : null}
                                <FormGroup row>
                                    <Label
                                        className={dataCertificate?.centerName ? "mt-3" : ""}
                                        for="customer_no">
                                        ประกอบกิจการประเภท
                                        <span
                                            className="require-input">
                                            *
                                        </span>
                                        {formik.touched.typeBusiness && formik.errors.typeBusiness ?
                                            <span className="text-left text-danger px-1">
                                                {formik.errors.typeBusiness}
                                            </span> : null
                                        }
                                    </Label>
                                    <Col>
                                        <Input
                                            className={
                                                formik.touched.typeBusiness && formik.errors.typeBusiness ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                            }
                                            type="text"
                                            name="typeBusiness"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.typeBusiness}
                                        >
                                        </Input>
                                    </Col>
                                </FormGroup>





                                {/* ที่อยู่ตามทะเบียนบ้าน */}
                                <div className="pt-3" >
                                    <Label
                                        for="address">ที่อยู่ตามทะเบียนบ้าน
                                        <span
                                            className="require-input">
                                            *
                                        </span>

                                        {formik.touched.addNo && formik.errors.addNo ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.addNo}
                                            </span>
                                            : null
                                        }
                                        {formik.touched.addTumbon && formik.errors.addTumbon ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.addTumbon}
                                            </span>
                                            : null
                                        }

                                        {formik.touched.addDistrict && formik.errors.addDistrict ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.addDistrict}
                                            </span>
                                            : null
                                        }

                                        {formik.touched.addProvince && formik.errors.addProvince ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.addProvince}
                                            </span>
                                            : null
                                        }
                                        {formik.touched.postcode && formik.errors.postcode ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.postcode}
                                            </span>
                                            : null
                                        }
                                    </Label>
                                    <div className="px-4 pt-4">
                                        <FormGroup row>
                                            <Label
                                                for="addNo"
                                                sm={2}
                                            >
                                                เลขที่
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="addNo"
                                                    name="addNo"
                                                    type="text"
                                                    className={formik.touched.addNo && formik.errors.addNo ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    onBlur={formik.handleBlur}
                                                    onChange={formik.handleChange}
                                                    value={formik.values.addNo}
                                                />
                                            </Col>

                                            <Label
                                                for="moo"
                                                sm={2}
                                            >
                                                หมู่ที่
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="addMoo"
                                                    name="addMoo"
                                                    type="text"
                                                    className="rounded-pill text-center input-color"
                                                    onChange={formik.handleChange}
                                                    value={formik.values.addMoo}
                                                />
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="soi"
                                                sm={2}
                                            >
                                                ซอย
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="addSoi"
                                                    name="addSoi"
                                                    type="text"
                                                    className="rounded-pill text-center input-color"
                                                    onChange={formik.handleChange}
                                                    value={formik.values.addSoi}
                                                />
                                            </Col>

                                            <Label
                                                for="street"
                                                sm={2}
                                            >
                                                ถนน
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="addStreet"
                                                    name="addStreet"
                                                    type="text"
                                                    className="rounded-pill text-center input-color"
                                                    onChange={formik.handleChange}
                                                    value={formik.values.addStreet}
                                                />
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="provinceId"
                                                sm={2}
                                            >
                                                จังหวัด
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="addProvince"
                                                    name="addProvince"
                                                    type="select"
                                                    
                                                    className={formik.touched.addProvince && formik.errors.addProvince ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    onBlur={formik.handleBlur}
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        GetAmphur(e)
                                                    }}
                                                    value={formik.values.addProvince}

                                                >
                                                    <option defaultValue value={"กรุณาเลือกจังหวัด"}>
                                                        กรุณาเลือกจังหวัด
                                                    </option>
                                                    {locationProvince.map(province => (
                                                        <option
                                                            key={province.provinceCode}
                                                            value={province.provinceCode}
                                                        >
                                                            {province.provinceName}
                                                        </option>
                                                    ))}
                                                </Input>
                                            </Col>

                                            <Label
                                                for="districtId"
                                                sm={2}
                                            >
                                                อำเภอ/เขต
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="addDistrict"
                                                    name="addDistrict"
                                                    type="select"
                                                    className={formik.touched.addDistrict && formik.errors.addDistrict ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    onBlur={formik.handleBlur}
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        GetTumbon(e)
                                                    }}
                                                    value={formik.values.addDistrict}
                                                >
                                                    <option defaultValue value={"กรุณาเลือกอำเภอ/เขต"}>
                                                        กรุณาเลือกอำเภอ/เขต
                                                    </option>
                                                    {locationAmphur.map(amphur => (
                                                        <option
                                                            key={amphur.amphurCode}
                                                            value={amphur.amphurCode}>
                                                            {amphur.amphurName}
                                                        </option>
                                                    ))}

                                                </Input>
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="tumbonId"
                                                sm={2}
                                            >
                                                ตำบล/แขวง
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="addTumbon"
                                                    name="addTumbon"
                                                    type="select"
                                                    className={formik.touched.addTumbon && formik.errors.addTumbon ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    onBlur={formik.handleBlur}
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        GetLocationsId(e)
                                                    }}
                                                    value={formik.values.addTumbon}
                                                >
                                                    <option defaultValue value={"กรุณาเลือกตำบล/แขวง"}>
                                                        กรุณาเลือกตำบล/แขวง
                                                    </option>
                                                    {locationTumbon.map(tumbon => (
                                                        <option
                                                            key={tumbon.tumbonCode}
                                                            value={tumbon.tumbonCode}
                                                        >
                                                            {tumbon.tumbonName}
                                                        </option>
                                                    ))}
                                                </Input>
                                            </Col>

                                            <Label
                                                for="postcode"
                                                sm={2}
                                            >
                                                รหัสไปรษณีย์
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    maxLength={5}
                                                    id="postcode"
                                                    name="postcode"
                                                    type="text"
                                                    className={formik.touched.postcode && formik.errors.postcode ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    onBlur={formik.handleBlur}
                                                    onChange={formik.handleChange}
                                                    value={formik.values.postcode}
                                                />
                                            </Col>
                                        </FormGroup>
                                    </div>
                                </div>

                                {/* ที่อยู่ปัจจุบัน */}
                                <div className="pt-3" >
                                    <Label
                                        for="address">ที่อยู่ปัจจุบัน(ที่ติดต่อได้)
                                        <span
                                            className="require-input">
                                            *
                                        </span>

                                        {formik.touched.curAddNo && formik.errors.curAddNo ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.curAddNo}
                                            </span>
                                            : null
                                        }
                                        {formik.touched.curAddTumbon && formik.errors.curAddTumbon ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.curAddTumbon}
                                            </span>
                                            : null
                                        }

                                        {formik.touched.curAddDistrict && formik.errors.curAddDistrict ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.curAddDistrict}
                                            </span>
                                            : null
                                        }

                                        {formik.touched.curAddProvince && formik.errors.curAddProvince ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.curAddProvince}
                                            </span>
                                            : null
                                        }
                                        {formik.touched.curPostcode && formik.errors.curPostcode ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.curPostcode}
                                            </span>
                                            : null
                                        }
                                    </Label>
                                    <div className="px-4 pt-4">
                                        <FormGroup>
                                            <Input
                                                type="checkbox"
                                                className="cus-type me-2"
                                                onClick={(e) => copyAddress(e)}
                                            />
                                            <Label>ใช้ที่อยู่ตามทะเบียนบ้าน</Label>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="curAdd_no"
                                                sm={2}
                                            >
                                                เลขที่
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="curAddNo"
                                                    name="curAddNo"
                                                    type="text"
                                                    className={
                                                        formik.touched.curAddNo && formik.errors.curAddNo ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    onBlur={formik.handleBlur}
                                                    onChange={formik.handleChange}
                                                    value={formik.values.curAddNo}
                                                />
                                            </Col>

                                            <Label
                                                for="moo"
                                                sm={2}
                                            >
                                                หมู่ที่
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="curAddMoo"
                                                    name="curAddMoo"
                                                    type="text"
                                                    className="rounded-pill text-center input-color"
                                                    onChange={formik.handleChange}
                                                    value={formik.values.curAddMoo}
                                                />
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="soi"
                                                sm={2}
                                            >
                                                ซอย
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="curAddSoi"
                                                    name="curAddSoi"
                                                    type="text"
                                                    className="rounded-pill text-center input-color"
                                                    onChange={formik.handleChange}
                                                    value={formik.values.curAddSoi}
                                                />
                                            </Col>

                                            <Label
                                                for="street"
                                                sm={2}
                                            >
                                                ถนน
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="curAddStreet"
                                                    name="curAddStreet"
                                                    type="text"
                                                    className="rounded-pill text-center input-color"
                                                    onChange={formik.handleChange}
                                                    value={formik.values.curAddStreet}
                                                />
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="province_id"
                                                sm={2}
                                            >
                                                จังหวัด
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="curAddProvince"
                                                    name="curAddProvince"
                                                    type="select"
                                                    className={formik.touched.curAddProvince && formik.errors.curAddProvince ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    onBlur={formik.handleBlur}
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        GetCurAmphur(e)
                                                    }}
                                                    value={formik.values.curAddProvince}

                                                >
                                                    <option defaultValue value={"กรุณาเลือกจังหวัด"}>
                                                        กรุณาเลือกจังหวัด
                                                    </option>
                                                    {locationCurProvince.map(province => (
                                                        <option
                                                            key={province.provinceCode}
                                                            value={province.provinceCode}
                                                        >
                                                            {province.provinceName}
                                                        </option>
                                                    ))}
                                                </Input>
                                            </Col>

                                            <Label
                                                for="districtId"
                                                sm={2}
                                            >
                                                อำเภอ/เขต
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="curAddDistrict"
                                                    name="curAddDistrict"
                                                    type="select"
                                                    className={formik.touched.curAddDistrict && formik.errors.curAddDistrict ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    onBlur={formik.handleBlur}
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        GetCurTumbon(e)
                                                    }}
                                                    value={formik.values.curAddDistrict}
                                                >
                                                    <option defaultValue value={"กรุณาเลือกอำเภอ/เขต"}>
                                                        กรุณาเลือกอำเภอ/เขต
                                                    </option>
                                                    {locationCurAmphur.map(amphur => (
                                                        <option
                                                            key={amphur.amphurCode}
                                                            value={amphur.amphurCode}>
                                                            {amphur.amphurName}
                                                        </option>
                                                    ))}
                                                </Input>
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="tumbonId"
                                                sm={2}
                                            >
                                                ตำบล/แขวง
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="curAddTumbon"
                                                    name="curAddTumbon"
                                                    type="select"
                                                    className={
                                                        formik.touched.curAddTumbon && formik.errors.curAddTumbon ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    onBlur={formik.handleBlur}
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        GetCurLocationsId(e)
                                                    }}
                                                    value={formik.values.curAddTumbon}
                                                >
                                                    <option defaultValue value={"กรุณาเลือกตำบล/แขวง"}>
                                                        กรุณาเลือกตำบล/แขวง
                                                    </option>
                                                    {locationCurTumbon.map(tumbon => (
                                                        <option
                                                            key={tumbon.tumbonCode}
                                                            value={tumbon.tumbonCode}
                                                        >
                                                            {tumbon.tumbonName}
                                                        </option>
                                                    ))}
                                                </Input>
                                            </Col>

                                            <Label
                                                for="curPostcode"
                                                sm={2}
                                            >
                                                รหัสไปรษณีย์
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    maxLength={5}
                                                    id="curPostcode"
                                                    name="curPostcode"
                                                    type="text"
                                                    className={
                                                        formik.touched.curPostcode && formik.errors.curPostcode ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    onBlur={formik.handleBlur}
                                                    onChange={formik.handleChange}
                                                    value={formik.values.curPostcode}
                                                />
                                            </Col>
                                        </FormGroup>
                                    </div>
                                </div>

                                {/* โทรศัพท์และโทรสาร */}
                                <Row className="pt-3">
                                    <Col>
                                        <Label
                                            for="tel">โทรศัพท์
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {formik.touched.tel && formik.errors.tel ?
                                                <span
                                                    className="text-left text-danger px-1">
                                                    {formik.errors.tel}
                                                </span>
                                                : null
                                            }
                                        </Label>
                                        <Col>
                                            <Input
                                                className={
                                                    formik.touched.tel && formik.errors.tel ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                }
                                                type="text"
                                                name="tel"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.tel}
                                            />
                                        </Col>
                                    </Col>

                                    <Col>
                                        <Label for="fax">
                                            โทรสาร
                                            {formik.touched.fax && formik.errors.fax ?
                                                <span className="text-left text-danger px-1">
                                                    {formik.errors.fax}
                                                </span> : null
                                            }
                                        </Label>
                                        <Col>
                                            <Input
                                                className=
                                                {formik.touched.fax && formik.errors.fax ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                }
                                                type="text"
                                                name="fax"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.fax}
                                            />
                                        </Col>
                                    </Col>
                                </Row>

                                {/* email */}
                                <FormGroup className="pt-3">
                                    <Label
                                        for="email">
                                        อีเมล
                                        <span
                                            className="require-input">
                                            *
                                        </span>
                                        {formik.touched.email && formik.errors.email ?
                                            <span className="text-left text-danger px-1">
                                                {formik.errors.email}
                                            </span>
                                            : null
                                        }
                                    </Label>
                                    <br />
                                    <Col>
                                        <Input
                                            className={
                                                formik.touched.email && formik.errors.email ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                            }
                                            type="text"
                                            name="email"
                                            id="email"
                                            // placeholder="example@gmail.com"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.email}

                                        />
                                    </Col>
                                </FormGroup>

                                {/* แนบไฟล์ใบทะเบียนพาณิชย์ */}
                                <FormGroup
                                    row
                                    className="pt-4" >
                                    <Label
                                        for="fCommercial">
                                        ใบทะเบียนพาณิชย์/ใบทะเบียนการค้าหรือเอกสารที่แสดงว่าประกอบธุรกิจ
                                        <span
                                            className="require-input">
                                            *
                                        </span>
                                        {formik.touched.fCommercial && formik.errors.fCommercial ?
                                            <span className="text-left text-danger px-1">
                                                {formik.errors.fCommercial}
                                            </span>
                                            : null
                                        }
                                    </Label>
                                    <br />
                                    <Col>
                                        <Input
                                            className={
                                                formik.touched.fCommercial && formik.errors.fCommercial ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                            }
                                            type="file"
                                            name="fCommercial"
                                            onChange={(e) => {
                                                formik.handleChange(e)
                                                if (e.target && e.target.files[0]) {
                                                    formik.setFieldValue("fCommercial", e.target.files[0])
                                                }
                                            }}
                                            onBlur={formik.handleBlur}
                                        />
                                        <FormText
                                            className="require-input">
                                            * ใบอนุญาตจัดตั้งศูนย์ทดสอบมาตรฐานฝีมือแรงงาน
                                        </FormText>
                                    </Col>
                                </FormGroup>



                                {/* รหัสผ่าน */}
                                <FormGroup row className="pt-3">
                                    <Label
                                        for="password">
                                        รหัสผ่าน
                                        <span
                                            className="require-input">
                                            *
                                        </span>
                                        {formik.touched.password && formik.errors.password ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.password}
                                            </span>
                                            : null
                                        }
                                    </Label>
                                    <Col className="position-relative">
                                        <Input
                                            id="password"
                                            name="password"
                                            type={isRevealPwd ? "text" : "password"}
                                            className={
                                                formik.touched.password && formik.errors.password ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                            }
                                            onBlur={formik.handleBlur}
                                            onChange={formik.handleChange}
                                            value={formik.values.password}
                                        />
                                        {isRevealPwd ? <BiShow className="icon-item-show-register"
                                            onClick={() => setIsRevealPwd(prevState => !prevState)}
                                        /> : <BiHide className="icon-item-show-register"
                                            onClick={() => setIsRevealPwd(prevState => !prevState)}
                                        />}
                                        <FormText
                                            className="require-input">
                                            * ภาษาอังกฤษ 8 ตัว ประกอบด้วย ตัวพิมพ์ใหญ่ พิมพ์เล็ก และตัวเลข
                                        </FormText>
                                    </Col>
                                </FormGroup>
                                <FormGroup className="pt-3">
                                    <Label
                                        for="cpassword">
                                        ยืนยันรหัสผ่าน
                                        <span
                                            className="require-input">
                                            *
                                        </span>
                                        {formik.touched.cpassword && formik.errors.cpassword ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.cpassword}
                                            </span>
                                            : null
                                        }
                                    </Label>
                                    <Col className="position-relative">
                                        <Input
                                            id="cpassword"
                                            name="cpassword"
                                            type={isRevealPwd2 ? "text" : "password"}
                                            className={
                                                formik.touched.cpassword && formik.errors.cpassword ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                            }
                                            onBlur={formik.handleBlur}
                                            onChange={formik.handleChange}
                                            value={formik.values.cpassword}
                                        />
                                        {isRevealPwd2 ? <BiShow className="icon-item-show-register-2"
                                            onClick={() => setIsRevealPwd2(prevState => !prevState)}
                                        /> : <BiHide className="icon-item-show-register-2"
                                            onClick={() => setIsRevealPwd2(prevState => !prevState)}
                                        />}
                                    </Col>
                                </FormGroup>
                                <FormGroup className="pt-3 d-flex">
                                    <Input
                                        type="checkbox"
                                        name="term"
                                        id="term"
                                        className=
                                        {formik.touched.term && formik.errors.term ?
                                            "input-error text-center input-color me-3" : "text-center input-color me-3 "
                                        }
                                        onBlur={formik.handleBlur}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                formik.setFieldValue("term", "Y")
                                            } else {
                                                formik.setFieldValue("term", "N")
                                            }
                                        }}
                                        value={formik.values.term}
                                        checked={formik.values.term === "Y"}
                                    />
                                    <Label for="term" className="w-100">
                                        ข้าพเจ้าได้อ่านและรับทราบ<a href="http://eit2.dsd.go.th/~pdpa/" target="blank">นโยบายการคุ้มครองข้อมูลส่วนบุคคลของกรมพัฒนาฝีมือแรงงาน</a>และยินยอมเปิดเผยข้อมูลส่วนบุคคลเพื่อใช้ประโยชน์ในการเชื่อมโยงและบูรณาการข้อมูลกับหน่วยงานภาครัฐ
                                        <span
                                            className="require-input">
                                            *
                                        </span>
                                        {formik.touched.term && formik.errors.term ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.term}
                                            </span>
                                            : null
                                        }
                                    </Label>

                                    {/* <Col className="position-relative">
                                        <Input
                                            id="cpassword"
                                            name="cpassword"
                                            type={isRevealPwd2 ? "text" : "password"}
                                            className={formik.touched.cpassword && formik.errors.cpassword ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                            onBlur={formik.handleBlur}
                                            onChange={formik.handleChange}
                                            value={formik.values.cpassword}
                                        />
                                        {isRevealPwd2 ? <BiShow className="icon-item-show-register-2"
                                            onClick={() => setIsRevealPwd2(prevState => !prevState)}
                                        /> : <BiHide className="icon-item-show-register-2"
                                            onClick={() => setIsRevealPwd2(prevState => !prevState)}
                                        />}
                                    </Col> */}
                                </FormGroup>
                                <div className="text-center p-5">
                                    <button
                                        className="submit-btn"
                                        type="submit">
                                        บันทึก
                                    </button>
                                </div>
                            </Form>
                        </div>
                    </Container>
                )
            }}
        </Formik>

    );


}


